export const FETCH_TYPES = 'FETCH_TYPES';
export const FETCH_TYPES_SUCCESS = 'FETCH_TYPES_SUCCESS';
export const FETCH_TYPES_ERROR = 'FETCH_TYPES_ERROR';

export const FETCH_INCIDENT_TYPES = 'FETCH_INCIDENT_TYPES';
export const FETCH_INCIDENT_TYPES_SUCCESS = 'FETCH_INCIDENT_TYPES_SUCCESS';
export const FETCH_INCIDENT_TYPES_ERROR = 'FETCH_INCIDENT_TYPES_ERROR';
